<template>
  <div class="main-container">
    <perfect-scrollbar>
      <app-main />
    </perfect-scrollbar>
  </div>
</template>

<script>
import { AppMain } from './components'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

export default {
  name: 'Layout',
  components: {
    AppMain,
    PerfectScrollbar
  },
  computed: {
    classObj() {
      return {
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.main-container {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>
